/*
 * This file contains a hook that locks or unlocks the body scroll.
 * It's useful when we'd like to display a full sized modal on top
 * of everything else.
 *
 * The lock goes on the body, not the root element. Locking the root makes
 * the body (overflow-y-scroll) its own scroll container, which pins sticky
 * side navs to the top of the page and hides them when the page is scrolled.
 * The stable scrollbar gutter keeps the page from widening when the
 * scrollbar disappears.
 */
import { useEffect } from 'preact/hooks';

let holders = 0;

export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) {
      return;
    }
    holders++;
    document.documentElement.style.scrollbarGutter = 'stable';
    document.body.style.overflow = 'hidden';

    return () => {
      holders = Math.max(0, holders - 1);
      if (!holders) {
        document.documentElement.style.scrollbarGutter = '';
        document.body.style.overflow = '';
      }
    };
  }, [locked]);
}
